import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const PurchaseTermsPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
        Pirkimo taisyklės ir pinigų grąžinimo politika
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Paskutinį kartą atnaujinta: {new Date().toLocaleDateString('lt-LT')}
      </Typography>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          1. Taikymo sritis
        </Typography>
        <Typography variant="body1" paragraph>
          Šios taisyklės taikomos teniso treniručių ir susijusių paslaugų pirkimui bei naudojimuisi per TenisoUžsiėmimai.lt rezervacijų sistemą. Naudodamiesi paslauga ir atlikdami užsakymą, sutinkate su šiomis taisyklėmis.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          2. Paslaugos teikimas
        </Typography>
        <Typography variant="body1" paragraph>
          Įsipareigojame suteikti užsakytą paslaugą sutartu laiku ir numatyta trukme, kaip nurodyta patvirtintoje rezervacijoje.
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 2, m: 0, '& li': { mb: 1 } }}>
          <li>
            <strong>Išimtinės aplinkybės.</strong> Jei dėl nuo mūsų nepriklausančių priežasčių (pvz., trenerio liga ar kita force majeure tipo situacija) ar dėl objektyvių priežasčių negalime užtikrinti aikštelės pageidaujamu laiku, informuosime jus kaip galima anksčiau ir, jei įmanoma, pasiūlysime alternatyvą (kitą laiką, trenerį ar pan.).
          </li>
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          3. Rezervacijos atšaukimas
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 2, m: 0, '& li': { mb: 1 } }}>
          <li>
            Treniruotę galite atšaukti patys rezervacijų sistemoje likus ne mažiau kaip <strong>60 valandų</strong> iki numatyto užsiėmimo pradžios.
          </li>
          <li>
            <strong>Mažiau nei 60 val.</strong> Jei iki treniruotės liko mažiau nei numatytas valandų skaičius ir nebegalite dalyvauti, prašome susisiekti su treneriu – individualiai galima derinti perkėlimą ar kitą sprendimą, tačiau tai neįpareigoja automatiškai grąžinti sumos pagal šios politikos 4 skyrių.
          </li>
          <li>
            <strong>Grupinės treniruotės (nuolatinė vieta).</strong> Jei rezervavote nuolatinę vietą grupinėse treniruotėse, atskiro (vienkartinio) užsiėmimo atšaukimas nėra negalimas. Tačiau šį laiką galite įkelti į parduodamų laikų skiltį. Pardavimui įvykus - pinigai grąžinami į jūsų piniginę.
          </li>
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          4. Pinigų grąžinimas į virtualią piniginę
        </Typography>
        <Typography variant="body1" paragraph>
          Jei rezervaciją atšaukiate pagal 3 skyriaus taisykles (per sistemą ir ne vėliau kaip likus 60 val. iki užsiėmimo), suma grąžinama į jūsų <strong>virtualią piniginę</strong> šioje platformoje. Lėšas galite panaudoti būsimoms paslaugoms įsigyti.
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          Virtualios piniginės balansas ir operacijos rodomi jūsų paskyroje (piniginės skiltyje).
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          5. Pinigų išmokėjimas į banko sąskaitą
        </Typography>
        <Typography variant="body1" paragraph>
          Jei nusprendžiate nebeįsigyti paslaugų ir norite išsiimti pinigus, kuriuos turite virtualioje piniginėje, prašymą ir banko sąskaitos duomenis pateikite <strong>piniginės skiltyje</strong> (nurodykite sąskaitą, į kurią pageidaujate gauti grąžinimą). Apdorojimo terminai ir minimali išmokėjimo suma (jei taikoma) gali būti nurodyti toje pačioje skiltyje arba atskirai pranešime.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          6. Kainos ir apmokėjimas
        </Typography>
        <Typography variant="body1" paragraph>
          Paslaugų kainos rodomos užsakymo metu. Pateikus užsakymą kaina yra fiksuojama tam individualiam užsakymui. Pateikdami užsakymą, patvirtinate, kad susipažinote su taikoma kaina ir mokėjimo tvarka.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          7. Taisyklių keitimas ir kontaktai
        </Typography>
        <Typography variant="body1" paragraph>
          Taisykles galime atnaujinti; pakeitimų data bus nurodyta šio puslapio viršuje. Esminiai pakeitimai dėl pinigų grąžinimo ar atšaukimo, kai reikalaujama įstatymų, bus komunikuojami protingu būdu (pvz., per svetainę ar el. paštą).
        </Typography>
        <Typography variant="body1" paragraph sx={{ mb: 0 }}>
          Klausimams dėl šių taisyklių ar konkretaus užsakymo naudokitės svetainėje nurodytais kontaktais arba trenerio kontaktinėmis priemonėmis.
        </Typography>
      </Paper>

      <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="body2" color="text.secondary">
          Jei nesutinkate su šiomis taisyklėmis, prašome neįsigyti paslaugų per šią sistemą.
        </Typography>
      </Box>
    </Container>
  );
};

export default PurchaseTermsPage;
